<div class="component-container">
    <table-panel header="Asortyment konkurencji" class="flex flex-grow">
        <pr-new-local-table
            panel-body
            [tableData]="data"
            [columnsData]="columnsData"
            [tableId]="tableId"
            [isLoading]="isLoadingTable"
            [selectedOption]="true"
            (selectedRows)="selectedRows($event)"
            [extraHeaderFieldTmpl]="extraHeader"
            #localTable
        >
            <ng-template #extraHeader>
                <div fxLayout="row">
                    <button-spinner class="ml-xxs" [inProgress]="importLoading">
                        <div (click)="export('xlsx')" style="cursor: pointer" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="toolbar-icon text-primary">cloud_download</mat-icon>
                            <span class="toolbar-icon-text" style="text-align:center">Eksportuj XLSX</span>
                        </div>
                    </button-spinner>
                    <button-spinner class="ml-xxs" [inProgress]="importLoading">
                        <div (click)="export('csv')" style="cursor: pointer" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="toolbar-icon text-primary">cloud_download</mat-icon>
                            <span class="toolbar-icon-text" style="text-align:center">Eksportuj CSV</span>
                        </div>
                    </button-spinner>
                    <button-spinner class="ml-xxs" [inProgress]="isDeleting">
                        <button
                            (click)="openDialog()"
                            [disabled]='isDeleteButtonDisabled'
                            mat-button
                            style="padding: 0;"
                        >
                            <span
                                fxLayout="column"
                                fxLayoutAlign="center center"
                            >
                                <mat-icon class="toolbar-icon text-primary">delete</mat-icon>
                                <span class="toolbar-icon-text" style="text-align:center; line-height: normal;">Usuń ceny</span>
                            </span>
                        </button>
                    </button-spinner>
                </div>
            </ng-template>
        </pr-new-local-table>
    </table-panel>
</div>

